import {useEffect, useRef, useState} from 'react';
import {useTranslation} from 'react-i18next';
import {DataActions, toDropinArrivalPerson, useArrivalContext} from 'src/context/ArrivalContext';
import {DropinArrivalRequest} from 'src/services/api/types/types';
import {performDropinArrival} from 'src/services/api/api';
import {Spinner} from 'src/components/layout/loader/Spinner';

import './DropinModalCompleted.scss';

interface DropInModalCompletedProps {
    onClose?: (arrivalId: number) => void;
}

export function DropinModalCompleted({onClose}: DropInModalCompletedProps) {
    const {t} = useTranslation();
    const {dispatch, dataState} = useArrivalContext();

    const [queueNumber, setQueueNumber] = useState(1);
    const [waitingTime, setWaitingTime] = useState(1);
    const [status, setStatus] = useState('loading');
    const timer = useRef<number>();

    const texts = t('arrival.booking_result.confirmed', {returnObjects: true}) as string[];

    function zeroPad(n: number): string {
        return n < 10 ? `0${n}` : `${n}`;
    }

    useEffect(() => {
        if (dataState.reasonState.appointmentType === null) return;

        const data: DropinArrivalRequest = {
            type: dataState.reasonState.appointmentType.id,
            patients: dataState.persons.map(toDropinArrivalPerson)
        };

        performDropinArrival(dataState.clinicId, data, null)
            .then((res) => {
                setQueueNumber(res.queueNumber);
                setWaitingTime(res.expectedWait);
                setStatus('ok');

                dispatch({
                    type: DataActions.SET_REASON_DATA,
                    value: {
                        category: null,
                        numberPatients: null,
                        appointmentType: null,
                        healthDeclarationDefinitionId: null,
                        allowedAge: null
                    }
                });

                dispatch({
                    type: DataActions.SET_TRIP,
                    value: {
                        trip: undefined,
                        tripDepartureDate: null
                    }
                });

                timer.current = window.setTimeout(async () => {
                    if (onClose) {
                        onClose(res.id);
                    }
                }, 7500);
            })
            .catch((e) => {
                setStatus('error');
            });

        return () => {
            window.clearTimeout(timer.current);
        };
    }, []);

    let content = <Spinner />;

    if (status === 'ok') {
        content = (
            <>
                <h1>{t('arrival.booking_result.confirmed_heading')}</h1>
                <p dangerouslySetInnerHTML={{__html: t('arrival.your_queue_number')}} />
                <div className='arrival-dropin-number-box'>{zeroPad(queueNumber)}</div>
                <p>
                    {texts.map((txt, ix) => (
                        <span key={ix}>
                            <span dangerouslySetInnerHTML={{__html: txt}} />
                            <br />
                        </span>
                    ))}
                </p>
            </>
        );
    } else if (status == 'error') {
        content = <div className='arrival-dropin-error'>{t('error_generic_title.text')}</div>;
    }

    return <div className='arrival-dropin-completed'>{content}</div>;
}
